export interface Location {
  country: string;
  regions: number[];
}

export function getCountriesFromLocations(locations: Location[]): string[] {
  return locations.map((l) => l.country);
}

export function getRegionsFromLocations(
  locations: Location[],
): Record<string, number[]> {
  return Object.fromEntries(locations.map((l) => [l.country, l.regions]));
}
